import { useQuery } from '@tanstack/react-query';

import { fetchLinkedInConfiguration } from '../api/configuration';
import type { LinkedInConfiguration } from '../types';
import { configurationKeys } from './queryKeys';

/**
 * The company's LinkedIn agent configuration, or **null** when it has not saved one.
 *
 * <p>Nothing saved is an answer and not a failure (LA-77), so the wizard opens empty and a screen
 * that needs the entry mode reads null as "none picked". Not retried: a 404 is settled, and a
 * failure is shown rather than hidden behind a spinner.
 */
export function useLinkedInConfiguration() {
  return useQuery<LinkedInConfiguration | null>({
    queryKey: configurationKeys.detail(),
    queryFn: fetchLinkedInConfiguration,
    retry: false,
  });
}
